import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Container, Card, Icon, AppBar, Toolbar } from "@mui/material";
import { fadeInUp } from "../../utils/animations";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import PageLayout from "examples/LayoutContainers/PageLayout";

import IconImage from "assets/images/logo.png";

const sections = [
  {
    title: "1. Propriétaire et éditeur de la plateforme",
    content:
      "La plateforme ConformIMF est la propriété de Monsieur Guy Modeste EHOULO, Expert en Audit, Conformité & Microfinance. ConformIMF regroupe les différents textes réglementaires publiés par les institutions de l\u2019espace UEMOA, destinés notamment aux Institutions de Microfinance (IMF). Contact : ehoulogm@yahoo.fr - Tél. : +229 01 66 36 65 22.",
  },
  {
    title: "2. Directeur de la publication",
    content:
      "Le directeur de la publication est Monsieur Guy Modeste EHOULO, en sa qualité de propriétaire et responsable de la plateforme ConformIMF.",
  },
  {
    title: "3. Hébergement",
    content:
      "La plateforme est hébergée sur des serveurs sécurisés. L\u2019hébergeur met en œuvre des mesures de sécurité conformes aux standards internationaux pour assurer la disponibilité et la protection des données.",
  },
  {
    title: "4. Objet de la plateforme",
    content:
      "ConformIMF est une plateforme de veille réglementaire permettant de centraliser, consulter et suivre l\u2019évolution de la réglementation applicable aux Institutions de Microfinance de l\u2019espace UEMOA. Elle regroupe les textes réglementaires publiés par les différentes institutions (BCEAO, Commission Bancaire, Conseil des Ministres, etc.).",
  },
  {
    title: "5. Propriété intellectuelle",
    content:
      "L\u2019ensemble des éléments de la plateforme (structure, interfaces, logos, charte graphique) est la propriété de M. Guy Modeste EHOULO. Les textes réglementaires reproduits sont des documents officiels publiés par les institutions de l\u2019UEMOA. Toute reproduction ou diffusion non autorisée des éléments propres à la plateforme est strictement interdite.",
  },
  {
    title: "6. Responsabilité",
    content:
      "Les textes réglementaires publiés sur la plateforme sont fournis à titre informatif. Seules les versions publiées au Journal Officiel font foi. L\u2019éditeur s\u2019efforce de maintenir des informations exactes et à jour, mais ne saurait être tenu responsable d\u2019erreurs, d\u2019omissions ou des résultats obtenus suite à l\u2019utilisation de ces informations.",
  },
  {
    title: "7. Accès à la plateforme",
    content:
      "L\u2019accès aux fonctionnalités avancées de la plateforme est réservé aux utilisateurs dûment autorisés par leur institution de rattachement. Certaines pages publiques (accueil, contact, documentation) sont librement accessibles. Le propriétaire se réserve le droit de suspendre ou de restreindre l\u2019accès pour des raisons de maintenance ou de sécurité.",
  },
  {
    title: "8. Liens hypertextes",
    content:
      "La plateforme peut contenir des liens vers des sites externes, notamment vers les sites officiels des institutions de l\u2019UEMOA. L\u2019éditeur n\u2019exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leur politique de confidentialité.",
  },
  {
    title: "9. Droit applicable",
    content:
      "Les présentes mentions légales sont régies par le droit applicable en République du Bénin et, subsidiairement, par le droit communautaire de l\u2019UEMOA. Tout litige relatif à l\u2019utilisation de la plateforme relève de la compétence des juridictions béninoises.",
  },
  {
    title: "10. Contact",
    content:
      "Pour toute question relative aux présentes mentions légales, vous pouvez contacter M. Guy Modeste EHOULO par email à ehoulogm@yahoo.fr ou par téléphone au +229 01 66 36 65 22. Date de dernière mise à jour : 2 avril 2026.",
  },
];

function MentionsLegales() {
  return (
    <PageLayout>
      <Helmet>
        <title>Mentions légales - ConformIMF</title>
        <meta
          name="description"
          content="Mentions légales de la plateforme ConformIMF : éditeur, responsable de publication, hébergeur et conditions d'utilisation de la plateforme de veille réglementaire UEMOA."
        />
        <meta property="og:title" content="Mentions légales - ConformIMF" />
        <meta
          property="og:description"
          content="Mentions légales de la plateforme ConformIMF : éditeur, responsable de publication et hébergeur."
        />
        <meta property="og:url" content="https://conformimf.com/mentions-legales" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Mentions légales - ConformIMF" />
        <meta
          name="twitter:description"
          content="Mentions légales de la plateforme ConformIMF : éditeur, responsable de publication et hébergeur."
        />
      </Helmet>

      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(16px)",
          boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
          py: 0.5,
          zIndex: 1100,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: "space-between", px: "0 !important" }}>
            <MDBox
              component={Link}
              to="/"
              display="flex"
              alignItems="center"
              sx={{ textDecoration: "none" }}
            >
              <MDBox component="img" src={IconImage} alt="Logo" width="200px" sx={{ mr: 1.5 }} />
            </MDBox>
            <MDButton
              variant="gradient"
              color="purple"
              size="small"
              component={Link}
              to="/"
              sx={{
                px: 3,
                transition: "transform 0.3s",
                "&:hover": { transform: "translateY(-2px)" },
              }}
            >
              <Icon sx={{ mr: 0.5 }}>arrow_back</Icon>
              Accueil
            </MDButton>
          </Toolbar>
        </Container>
      </AppBar>

      <MDBox sx={{ pt: 12, pb: 6, minHeight: "100vh", backgroundColor: "#fafafa" }}>
        <Container maxWidth="md">
          <MDBox textAlign="center" mb={5} sx={{ animation: `${fadeInUp} 0.6s ease-out both` }}>
            <Icon sx={{ fontSize: "48px !important", color: "#186A81", mb: 2 }}>gavel</Icon>
            <MDTypography variant="h2" fontWeight="bold" mb={1}>
              Mentions légales
            </MDTypography>
            <MDTypography variant="body1" color="text" sx={{ opacity: 0.8 }}>
              Informations légales relatives à la plateforme ConformIMF.
            </MDTypography>
          </MDBox>

          {sections.map((section, i) => (
            <Card
              key={i}
              sx={{
                p: 3.5,
                mb: 2.5,
                borderRadius: "16px",
                animation: `${fadeInUp} 0.5s ease-out ${0.1 + i * 0.08}s both`,
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(123,31,162,0.08)",
                },
              }}
            >
              <MDBox display="flex" alignItems="center" mb={1.5}>
                <Icon sx={{ color: "#186A81", mr: 1.5, fontSize: "22px" }}>article</Icon>
                <MDTypography variant="h6" fontWeight="bold">
                  {section.title}
                </MDTypography>
              </MDBox>
              <MDTypography
                variant="body2"
                color="text"
                sx={{ lineHeight: 1.8, opacity: 0.85, pl: 4.5 }}
              >
                {section.content}
              </MDTypography>
            </Card>
          ))}
        </Container>

        <MDBox textAlign="center" mt={8}>
          <MDTypography variant="caption" color="text" sx={{ opacity: 0.5 }}>
            &copy; 2026 ConformIMF - Guy Modeste EHOULO - Tous droits réservés
          </MDTypography>
        </MDBox>
      </MDBox>
    </PageLayout>
  );
}

export default MentionsLegales;
